import "vuetify/styles";
import { createVuetify as _createVuetify } from "vuetify";
import { vuetifySettings } from "@/vuetify";

export const createVuetify = () => {
	return _createVuetify(vuetifySettings);
};

export default createVuetify;
